import React from "react";
import PropTypes from "prop-types";
import { Alert, TemporaryContent, Section } from "../common";

const AlertaTemporario = (props) => {
  const { sectionName, startIn, stopIn, children, icon } = props;

  return (
    <TemporaryContent startIn={startIn} stopIn={stopIn}>
      <Section {...props} sectionName={sectionName}>
        <Alert icon={icon}>{children}</Alert>
      </Section>
    </TemporaryContent>
  );
};

AlertaTemporario.defaultProps = {
  ...TemporaryContent.defaultProps,
};

AlertaTemporario.propTypes = {
  sectionName: PropTypes.string.isRequired,
  ...TemporaryContent.propTypes,
};

export default AlertaTemporario;
